<script>
import DatePicker from "vue2-datepicker";
import { FILTER_TYPE } from "@/views/app/dashboard/history/data/constants";

export default {
  name: "HistoryFilter",

  props: {
    items: {
      required: true,
    },
    historyType: {
      required: true,
    },
  },

  components: { DatePicker },

  data: () => ({
    filter: {},
    filterItems: [FILTER_TYPE.Withdrawals, FILTER_TYPE.Purchases],
  }),

  methods: {
    filterByType(item) {
      return (
        this.historyType !== "transaction" ||
        !this.filter.type ||
        item.type === this.filter.type
      );
    },

    filterByStatus(item) {
      return (
        this.historyType !== "bonus" ||
        !this.filter.status ||
        item.status.toUpperCase() === this.filter.status.toUpperCase()
      );
    },

    filterByDateRange(item) {
      if (!this.filter.dateRange || this.filter.dateRange.length !== 2) {
        return true;
      }

      const [from, to] = this.filter.dateRange;
      const itemDate = new Date(item.date);

      if (from && itemDate < new Date(from.setHours(0, 0, 0, 0))) {
        return false;
      }

      return !(to && itemDate > new Date(to.setHours(23, 59, 59, 999)));
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const filteredItems = this.items.filter((item) => {
        return (
          this.filterByType(item) &&
          this.filterByStatus(item) &&
          this.filterByDateRange(item)
        );
      });

      this.$emit("filter", filteredItems);
    },
    resetForm() {
      this.$refs.form.reset();
      this.filter.dateRange = null;
      this.$emit("filter", null);
    },
  },
};
</script>

<template>
  <v-form ref="form" lazy-validation @submit.prevent="submit">
    <v-row
      :class="{
        'mr-6': $vuetify.breakpoint.mdAndUp,
        'mobile-version': $vuetify.breakpoint.smAndDown,
      }"
    >
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        class="input-container"
        v-if="historyType === 'transaction'"
      >
        <div class="label">Type</div>
        <v-select
          v-model="filter.type"
          :items="filterItems"
          :menu-props="{ offsetY: true, nudgeTop: '1px' }"
          :rules="[]"
          placeholder="All"
          append-icon="mdi-chevron-down"
          persistent-placeholder
          filled
          attach
          outlined
          hide-details
          dense
          class="formFieldSuperCompact"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
        class="input-container"
        v-if="historyType === 'bonus'"
      >
        <div class="label">Status</div>
        <v-select
          v-model="filter.status"
          :items="['Active', 'Expired', 'Pending', 'Wagered', 'Spent']"
          :menu-props="{ offsetY: true, nudgeTop: '1px' }"
          :rules="[]"
          placeholder="All"
          append-icon="mdi-chevron-down"
          persistent-placeholder
          filled
          outlined
          hide-details
          attach
          dense
          class="formFieldSuperCompact"
        />
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="6" class="input-container position-relative">
        <div class="label">From ~ To</div>
        <date-picker
          v-model="filter.dateRange"
          placeholder="Pick a date range"
          range
          class="date-range-picker"
          :append-to-body="false"
          :popup-style="{
            'z-index': 4,
            'top': 0
          }"
        />
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="3"
        :class="$vuetify.breakpoint.lgAndUp ? 'mt-7' : ''"
      >
        <v-row>
          <v-col cols="6" class="py-0 pr-0">
            <v-btn color="green-light" elevation="0" width="100%" type="submit">
              <span
                class="white--text font-weight-superbold non-italic font-size-20"
              >
                Filter
              </span>
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            :class="$vuetify.breakpoint.lgAndUp ? 'pr-0 ' : ''"
            class="py-0 pl-3"
          >
            <v-btn
              color="black"
              elevation="0"
              width="100%"
              class="rounded"
              @click="resetForm()"
            >
              <span
                class="white--text non-italic font-weight-superbold font-size-20"
              >
                Reset
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<style lang="scss" scoped>

.formFieldSuperCompact::v-deep {
  .v-menu__content {
    z-index: 4 !important;
  }
}

.date-range-picker::v-deep {
  width: 100%;
  height: 38px;

  input {
    height: 38px;
    border-radius: 10px;
  }
}

.non-italic {
  font-style: normal !important;
}

.mobile-version {
  margin-right: 2px;

  .label {
    font-size: 20px;
    font-weight: 500;
    font-style: italic;
    color: white;
    padding-left: 16px;
    margin-bottom: 4px;
  }
}

@media screen and (max-width: 600px) {
  .input-container {
    .label {
      display: none;
    }
  }
}
</style>
